const es = {
    new_product: 'Nuevo produto',
    select_active: 'Solo Activos',
    placeholder_search_reg: 'Buscar registro',
    sku:'SKU',
    description:'Descripción',
    brand:'Marca',
    price:'Precio',
    stock:'Cantidad',
    active:'Activo',
    deactive:'Desactivo',
    options:'Opciones',
    edit: 'Editar',
    delete: 'Eliminar',
    save:'Guardar',
    sku_used: 'Sku usado',
    catalogue:'Catalogo',
    product:'Productos',
    new:'Nuevo',
    back:'Atras'
}

export default es;